export default __webpack_public_path__ + "static/media/hicaps.b9d7ce8d.svg";